
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/premium-plan-release",
      function () {
        return require("private-next-pages/blog/premium-plan-release.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/premium-plan-release"])
      });
    }
  